import React, { useState } from "react";
import { formatDate, formatTime } from "../../../common/utils";
import { saveNote } from "../../../features/notes/notesSlice";
import moment from "moment";

function NotesChild({
  name,
  time,
  section,
  description,
  notes,
  setNotes,
  ID,
  childID,
  userLogin,
  t,
  dispatch,
  userId,
  id,
  standardNoteID,
  lang,
  childNotes,
  isAddedByInternalUser,
}) {
  const [reply, setReply] = useState(false);
  const [replyText, setReplyText] = useState("");
  const [showAll, setShowAll] = useState(false);
  return (
    <div
      className={`${
        !isAddedByInternalUser && "bg-[#FAFAFA]"
      } border-l-4 mx-[12px] note__reply pl-[18px] pr-[12px]`}
      key={childID}
      style={{ marginLeft: 70 }}
    >
      <div className="border-[#D9D9D9] border-b flex flex-row pb-[24px] pt-[24px]">
        <div className="flex flex-col items-start w-[145px]">
          <p className="font-[600]">
            {(time && moment(time).format("ll")) || "12/27/2022"}
          </p>
          <p>{(time && moment(time).format("hh:mm A")) || "11:30:47 AM"}</p>
        </div>
        <div className="flex w-[250px]">{name || "tkomasegfha"}</div>
        <div className="flex flex-col w-[620px]">
          <div className="flex flex-row">
            <svg className="self-baseline" width="24" height="24" fill="none">
              <path
                d="m15 10 5 5-5 5"
                stroke="#595959"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4 4v7a4 4 0 0 0 4 4h12"
                stroke="#595959"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="w-[80%]">
              {showAll ? (
                <span dangerouslySetInnerHTML={{ __html: description }}></span>
              ) : (
                <span
                  dangerouslySetInnerHTML={{
                    __html: description.substr(0, 50),
                  }}
                ></span>
              )}{" "}
            </p>
          </div>{" "}
          <div className="flex flex-flow gap-6 mt-2 pr-[120px] self-end">
            {" "}
            {description && description.length > 47 && (
              <div className="flex flex-row">
                <button
                  onClick={() => setShowAll((prev) => !prev)}
                  id="show-more"
                  type="button"
                  className="flex link self-center"
                >
                  {showAll ? t("showLess") : t("showMore")}
                </button>
                {showAll ? (
                  <svg
                    className="ml-3 self-center hide-arrow"
                    width="20"
                    height="20"
                    fill="none"
                  >
                    <path
                      d="M4.076 6.309 10 11.693l5.923-5.384"
                      stroke="#526D7D"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    className="ml-3 self-center show-arrow"
                    width="20"
                    height="20"
                    fill="none"
                  >
                    <path
                      d="M4.076 11.691 10 6.307l5.923 5.384"
                      stroke="#526D7D"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </div>
            )}
          </div>
        </div>
        {/* <div className="flex justify-end w-[113px]">
          {reply && (
            <div className="flex gap-[16px] self-end">
              <button
                onClick={() => setReply((prev) => !prev)}
                type="reset"
                className="focus-visible:bg-[#ECECEC] font-[600] h-[40px] hover:bg-[#ECECEC] leading-[21.79px] rounded-sm text-[#E2211C] text-[16px] text-center w-[68px]"
              >
                {t("cancel")}
              </button>
              <button
                type="button"
                id="save-reply"
                onClick={() => {
                  dispatch(
                    saveNote(
                      parseInt(id) - 100000,
                      replyText,
                      userId,
                      ID,
                      (threadID = 1)
                    )
                  );
                  // let allNotes = [...notes];
                  // let currentNote = allNotes.find(({ id }) => id === ID);
                  // currentNote.childNotes = [
                  //   ...currentNote.childNotes,
                  //   {
                  //     category: section,
                  //     description: replyText,
                  //     id: currentNote.childNotes?.length + 1,
                  //     section: section,
                  //     time: new Date(),
                  //     name: userLogin.firstName + ' ' + userLogin.lastName,
                  //     childNotes: [],
                  //   },
                  // ];
                  setReplyText("");
                  setReply((prev) => !prev);
                  // setNotes(allNotes);
                }}
                className="!bg-primary-yellow !border-0 break-keep btn__secondary font-[600] h-[40px] items-end leading-[21.79px] px-[16px] text-[#231F20] text-[16px] text-center w-[75px]"
              >
                {t("save")}
              </button>
            </div>
          )}
          {!reply && (
            <div className="self-center">
              <button
                id="reply"
                onClick={() => setReply((prev) => !prev)}
                className="break-keep btn__secondary font-[600] h-[40px] leading-[21.79px] px-[16px] text-[#231F20] text-[16px] text-center w-[75px]"
              >
                {t("reply")}
              </button>
            </div>
          )}
        </div> */}
      </div>
    </div>
  );
}

export default React.memo(NotesChild);
